/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import 'moment/locale/pt';

import { Box, Button, Typography } from '@mui/material';
import CustomizedTables from '../../../components/Table';
import FixedContainer from '../../../components/Container';
import LoadingComponent from '../../../components/LoadingComponent';
import { useNavigate } from 'react-router-dom';
import { GetFetch, urls } from '../../../services/apiBase';
import { useAuth } from '../../../hooks/auth';

const Opportunity = () => {
  const { user } = useAuth();
  
  const [opportunities, setOpportunities] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  const navigate = useNavigate()

  const COLUMNSTABLE = [
    {
      headerName: "Título",
      type: "default",
      value: {
        first: {
          value: "title",
        },
      },
      noData: "Não informado",
    },
    {
      headerName: "Duração",
      type: "default",
      value: {
        first: {
          value: "duration",
        },
      },
      noData: "Não informado",
    },
    {
      headerName: "Unidade de duração",
      type: "duration_unit",
      value: {
        first: {
          value: "duration_unit",
        },
      },
      noData: "Não informado",
    },
    {
      headerName: "Data de geração",
      type: "date",
      value: {
        first: {
          value: "date_start",
        },
      },
    },
    {
      headerName: "Data de início",
      type: "date",
      value: {
        first: {
          value: "date_start",
        },
      },
    },
    {
      headerName: "Data final",
      type: "date",
      value: {
        first: {
          value: "date_end",
        },
      },
    },
    {
      headerName: "Valor mínimo",
      type: "money",
      value: {
        first: {
          value: "min_amount",
        },
      },
    },
    {
      headerName: "Valor máximo",
      type: "money",
      value: {
        first: {
          value: "max_amount",
        },
      },
    },
    {
      headerName: "Taxa",
      type: "percent",
      value: {
        first: {
          value: "rate",
        },
      },
    },
    {
      headerName: "Status",
      type: "bool",
      value: {
        first: {
          value: "is_active",
        },
      },
      trueMessage: "Ativa",
      falseMessage: "Inativa",
      noData: "Não informado",
    },
  ];

  const getOpportunities = useCallback(async () => {
    setLoading(true)
    try {

      let url = urls.GET_LIST_ALL_OPPORTUNITIES.concat(
        `?personne_id=${user.personne_id}`
      );
      const response = await GetFetch(url, { personne_id: user.personne_id });

      if (!response.data.error) {
        const ordered = response.data.sort((a, b) => a.cpr_number < b.cpr_number ? 1 : -1);
        setOpportunities(ordered);
      } else {
        setOpportunities('No momento não há CPRS geradas')
      }
      setError(false)

    } catch (error) {
      setError(true)
    } finally {
      setLoading(false);
    }
  }, []);

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as oportunidades
        </Typography>
      </Box>
    )
  }

  const handleOpenCprfsList = (opportunityId, personneId, opportunity) => {
    return navigate("/cprf/byOpportunity", {
      state: {
        opportunityId: opportunityId,
        personneId: personneId,
        opportunity: opportunity,
      },
    });
  };

  const openCprfsListButtonComponent = (opportunity) => {
    return (
      <Button
        variant="contained"
        color="success"
        sx={{ marginRight: 1 }}
        onClick={() =>
          handleOpenCprfsList(opportunity.id, user.personne_id, opportunity)
        }
      >
        Visualizar
      </Button>
    );
  };

  const tableComponent = () => {
    return (
      <Box>
        <CustomizedTables
          data={opportunities}
          columns={COLUMNSTABLE}
          moreOptionsTitle={"Visualizar CPRFs"}
          moreOptions={openCprfsListButtonComponent}
        />
      </Box>
    );
  }
  
  useEffect(() => {
    getOpportunities();
  }, [getOpportunities]);

  return (
    <FixedContainer>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#F9FBFD",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          boxShadow: 3,
          borderRadius: "10px",
          padding: 2,
        }}
      >
        {loading ? (
          <LoadingComponent />
        ) : error ? (
          errorMessage()
        ) : opportunities && opportunities.length < 1 ? (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
            >
              No momento não existem oportunidades criadas
            </Typography>
          </Box>
        ) : (
          <>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 1 }}
            >
              CPRF's/Oportunidades
            </Typography>

            {tableComponent()}
          </>
        )}
      </Box>
    </FixedContainer>
  );
}

export default Opportunity;
